<template>
  <div class="contentHeader" v-if="signedIn">
    <div class="menuToggle" v-if="!canGoBack"></div>
    <div class="backBtn" v-else v-on:click="$router.go(-1)"></div>

    <h4>{{title}}</h4>
    <div class="user">

      <div :class="{userPict: true, hasPhoto: $session.get('avatar')}"
        :style="{'background-image': `url('${$session.get('avatar')}')`}"
        v-on:click="userOpen = true">
        <span>{{$session.get('name').substr(0,2)}}</span>
      </div>
      <div :class="{userMenuCnt: true, open: userOpen}">
        <div class="userOverlay" v-on:click="userOpen = false"></div>
        <div class="userMenu" v-on:click="userOpen = false">
          <h4>{{$session.get('name')}}</h4>
          <p>{{$session.get('email')}}</p>
          <div class="welcomeToV2">
            <h4>Welcome to new Nutrilite Dashboard</h4>
            <p>You still can visit previous version of Nutrilite Dashboard
              via link below.</p>
            <a href="/admin-v1">Visit Previous Version</a>
          </div>
          <ul>
            <li><router-link to="/user/account">Account</router-link></li>
            <li class="divider"></li>
            <li><span v-on:click="signoutConfirmOpen = true">Sing Out</span></li>
          </ul>
        </div>
      </div>
    </div>
    <div class="notif">
      <div class="notifIcon"></div>
    </div>

    <transition name="fade">
      <div class="modal" v-if="signoutConfirmOpen">
        <div class="modalContent">
          <h4>Sign Out?</h4>
          <p>Are you sure you want to sign out from Sayangi Anak Ekstra admin?<br />
            You can always sign in back at any times.</p>
          <div class="lcAction">
            <button class="btn btnSecondary" v-on:click="signoutConfirmOpen = false">Cancel</button>
            <button class="btn btnPrimary" v-on:click="logout">Sign Out</button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  name: 'contentHeader',
  data() {
    return {
      userOpen: false,
      signoutConfirmOpen: false,
    };
  },
  computed: {
    ...mapState([
      'title', 'canGoBack', 'signedIn',
    ]),
  },
  methods: {
    ...mapActions([
      'chSignIn',
    ]),
    logout() {
      this.$session.destroy();
      this.$router.push('/signin');
      this.chSignIn(false);
    },
  },
};
</script>

<style scoped lang="scss">
  .welcomeToV2{
    background-color: #82bf32;
    color: #fff;
    padding: 20px 0;
    margin-bottom: 10px;
    h4{
      color: #fff;
      margin: 0 0 6px;
      font-size: 21px;
      font-weight: bold;
    }
    p{
      color: #fff !important;
    }
    a{
      background-color: #fff;
      color: #4e7914;
      border-radius: 5px;
      padding: 8px 16px;
      margin: 0 0 6px 30px;
      display: inline-block;
      font-weight: 600;
      box-shadow: 2px 2px 4px rgba(0,0,0,.1);
      transition: all .3s ease;
      &:hover{
        background-color: #edf3e6;
        box-shadow: 2px 2px 4px rgba(0,0,0,.2);
      }
    }
  }

  .contentHeader{
    position: absolute;
    top: 0;
    right: 0;
    left: 300px;
    padding: 4px 22px;
    // background-color: #f5f5f5;
    border-bottom: #eee 1px solid;
    z-index: 9;
    background-color: #fff;
  }
  .backBtn,
  .menuToggle{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background-image: url(../assets/menu.png);
    background-size: 20px auto;
    background-position: center;
    background-repeat: no-repeat;
    opacity: 1;
    float: left;
    margin-right: 10px;
    cursor: pointer;
  }
  .backBtn{
    background-image: url(../assets/back-arrow.png);
  }
  .menuToggle:hover{
    background-color: #e5e5e5;
  }
  h4{
    color: #444;
    font-size: 26px;
    font-weight: normal;
    margin: 0;
    padding-top: 2px;
  }
  .user{
    position: absolute;
    right: 20px;
    top: 4px;
    width: 39px;
    height: 39px;
    .userPict{
      position: absolute;
      right: 0; top: 0;
      width: 39px; height: 39px;
      background-color: #0e5dd2;
      // background-image: url(../assets/user.png);
      background-size: cover;
      border-radius: 50%;
      cursor: pointer;

      background-position: center;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      text-transform: uppercase;
      line-height: 0;
      &.hasPhoto{
        span{
          display: none;
        }
      }
    }
  }
  .notif{
    width: 39px;
    height: 39px;
    top: 4px;
    position: absolute;
    right: 70px;
    border-radius: 50%;
    cursor: pointer;
    .notifIcon{
      position: absolute;
      top: 0; right: 0; left: 0; bottom: 0;
      background-image: url(../assets/notification.png);
      background-size: 24px auto;
      background-position: center;
      background-repeat: no-repeat;
      opacity: .7;
    }
  }
  .notif:hover{
    background-color: #e5e5e5;
  }

  .userMenuCnt{
    position: relative;
    display: none;
    .userOverlay{
      position: fixed;
      top: 0; right: 0; left: 0; bottom: 0;
      z-index: 1;
    }
    .userMenu{
      position: absolute;
      top: 40px;
      right: -10px;
      z-index: 9;
      background: #fff;
      box-shadow: 2px 2px 8px rgba(0,0,0,.2);
      padding: 15px 0;
      border-radius: 5px;
      width: 280px;
      h4{
        margin: 0;
        padding: 0 30px;
      }
      p{
        margin: 0;
        padding: 0 30px;
        color: #767676;
        font-size: 15px;
        // border-bottom: #eee 1px solid;
        padding-bottom: 14px;
        // margin-bottom: 10px;
      }
      ul{
        margin: 0;
        padding: 0;
        li{
          list-style: none;
          a, span{
            color: #444;
            display: block;
            padding: 8px 30px;
            font-size: 17px;
            cursor: pointer;
          }
        }
        li.divider{
          border-bottom: #eee 1px solid;
          padding-top: 5px;
          margin-bottom: 5px;
        }
        li:hover{
          a, span{
            background-color: #eee;
          }
        }
      }
    }
  }
  .userMenuCnt.open{
    display: block;
  }
  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 9;
    display: flex;
    // background-color: #fff;
    background-color: rgba(0,0,0,.7);
    align-items: center;
    justify-content: center;
    .modalContent{
      width: 450px;
      padding: 30px;
      text-align: center;
      background-color: #fff;
      border-radius: 5px;
      h4{
        margin: 0;
        color: #444;
        font-size: 32px;
        margin-bottom: 5px;
      }
      p{
        margin: 0;
        color: #767676;
        margin-bottom: 30px;
      }
      .lcAction{
        margin: 30px -30px -30px;
        padding: 10px 20px;
        text-align: right;
        border-top: #eee 1px solid;
        .btn{
          margin-left: 10px;
        }
      }
    }
  }
</style>
